import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	and: {
		id: 'jql-builder-basic-datetime.between-dates.and',
		defaultMessage: 'and',
		description: 'Conjunction connecting start and end dates in a date interval',
	},
	startDateLabel: {
		id: 'jql-builder-basic-datetime.between-dates.start-date-label',
		defaultMessage: 'Choose a start date',
		description: 'Label for the start date',
	},
	endDateLabel: {
		id: 'jql-builder-basic-datetime.between-dates.end-date-label',
		defaultMessage: 'Choose an end date',
		description: 'Label for the end date',
	},
});
